<template>
  <div class="layout-product-tab">
    <div :class="[{ opened }]" @click="toggle" class="header row-between">
      <div class="s-20 w-500"><h2>{{ name }}</h2></div>
      <icon-plus v-if="!opened"></icon-plus>
      <icon-minus v-else></icon-minus>
    </div>
    <div v-if="opened" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      opened: false
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened

      if( this.opened == true && this.name === "Где полежать" ){
        if (typeof (ym) === "function") {
          let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
          ym(yaCounterId2, 'reachGoal', 'open_block_address');
        }
      }

    }
  },
  created() {
    if (this.name === "Характеристики") {
      this.opened = true
    }
  },
  components: {
    iconPlus: () => import('@/components/icon/icon-plus.vue'),
    iconMinus: () => import('@/components/icon/icon-minus.vue')
  }
}
</script>

<style lang="scss" scoped>
.layout-product-tab {
}
.header {
  padding: 1em 0;
  border-top: solid 1px rgba(0, 0, 0, 0.1);
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  &.opened {
    border-bottom-color: transparent;
  }
}
.content {
  padding-bottom: 1em;
}
</style>
